import e from "react";
import { Avatar as o } from "../Avatar/Avatar.js";
import { Text as s } from "../Text/Text.js";
import { useGetLoginInfo as l } from "../Header/services/useGetLoginInfo.js";
const i = _ref => {
  let {
    teamKey: r
  } = _ref;
  const {
    profilePicture: a,
    userName: t
  } = l({
    teamKey: r
  });
  return t ? e.createElement("span", {
    className: "olx-focus-header__profile-container",
    "data-testid": "static-user-profile"
  }, e.createElement(o, {
    size: "32px",
    className: "olx-focus-header__profile-avatar",
    src: a
  }), e.createElement(s.BodySmall, {
    weight: "semibold",
    className: "olx-focus-header__profile-username"
  }, t.split(" ")[0])) : null;
};
export { i as StaticUserProfile };